import React, { useEffect, useRef, useState } from 'react'
import { addDevamliAraclarPlaka, addSiraListesi, clearJobListWithoutGunlukAraclar, deleteDevamliAraclarPlaka, getDevamliAracItem, multipleCitySelectArray, setSelectedPlateNumber, setSelectedTrailerPlateNumber, updateVehicle } from '../../../features/joblist/jobListSlice';
import { showModal } from '../../../features/modal/modalSlice';
import Btn from '../../shared/button/Btn';
import bolgeOptions from '../../../utils/yukOptions/bolgeOptions';
import iller from '../../../utils/iller';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import GidebilecekIllerInput from '../queueInputs/GidebilecekIllerInput';
import GidebilecekBolgelerInput from '../queueInputs/GidebilecekBolgelerInput';
import DateInput from '../inputs/DateInput';
import AracNeredeInput from '../queueInputs/AracNeredeInput';
import SelectAracDurumuInput from '../queueInputs/SelectAracDurumuInput';
import KasaTipiInput from '../inputs/KasaTipiInput';
import SelectAracInput from '../inputs/SelectAracInput';
import PlateInput from '../inputs/PlateInput';
import BoolInput from '../inputs/BoolInput';
import InputPhoneFormat from '../../shared/input/new/InputPhoneFormat';
import TextInput from '../inputs/TextInput';
import { AdminAracEkleOptions } from '../../../utils/adminAracEkleOptions';
import locationData from '../../../utils/locationData/locationOptions';
import SmallSpinner from '../../shared/spinners/SmallSpinner';

const Container = styled.div`
    width: 60%;
    margin: 0 auto;
    .inputs{
        padding: 10px 0px;
        width: 100%;
        .daily-inputs{
            border-top: 2px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            padding-top: 20px;
            margin-top: 20px;
            .title{
                font-size: var(--font-size-lg);
                font-weight: var(--font-weight-md);
            }
        }
        .row{
            margin-block: 15px;
            .select-plate{
                color: var(--color-main);
                border: 1px solid var(--color-main);
                padding: 5px;
                border-radius: 10px;
                font-size: var(--font-size-sm);
                width: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
            .selected-plate{
                color: white;
                background-color: var(--color-main);
                border: 1px solid var(--color-main);
                padding: 5px;
                border-radius: 10px;
                font-size: var(--font-size-sm);
                width: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
        .btn{
            width: 100%;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            gap: 15px;
            button{
                padding: 10px;
            }
        }
            
    }
    .space{
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .err{
        font-size: 14px;
        color: var(--color-main);
        margin-block: 10px;
    }

    @media (max-width: 1150px){
        
        .inputs{
            width: 100% !important;
            .row{
                padding-inline: 20px;
                .add-plate{
                    right: 3%;
                }
            }
        }
        .title{
            padding-inline: 20px;
        }
    }
`

const BoolData = [
    {
        id:1,
        text:"Evet",
        bool:true
    },
    {
        id:2,
        text:"Hayır",
        bool:false
    }
]

const aracDurumu = [
    {
        id: 1,
        text: "Boşta Hazır",
    },
    {
        id: 2,
        text: "Yük Boşaltıyor",
    },
    {
        id: 3,
        text: "Yolda",
    },
    {
        id: 4,
        text: "Yarın Boşta",
    },
];

const NewUserContent = () => {
    const dispatch = useDispatch()
    const bottomRef = useRef(null);
    const [isSubmitted, setIsSubmitted] = useState(false)

    const [phoneValue, setPhoneValue] = useState("")
    const {activeSelect} = useSelector(state => state.layout)

    const {dailyVehicleList, vehicleData, loadingAddDriver, selectedPlateNumber, selectedTrailerPlateNumber, errorMessage, isForGunlukArac} = useSelector((state) => state.jobList)
    const { devamliAraclarPlakas, firstLastName, phoneNumber, isContinueVehicle, isReferenceDriver} = vehicleData
    const { vehicleStatus, vehicleCurrentLocation, timeToWaste, gunlukAracListesiCityCanGos, gunlukAracListesiRegionCanGos } = dailyVehicleList;

    useEffect(() => {
        dispatch(updateVehicle({ keyData: "phoneNumber", value: phoneValue}) );
    }, [phoneValue])

    useEffect(() => {
        if ((activeSelect === 'gunlukAracListesiRegionCanGos' || activeSelect === 'gunlukAracListesiCityCanGos') && bottomRef.current) {
        bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [activeSelect]);

    useEffect(() => {
        const selectedCities = gunlukAracListesiRegionCanGos.map((item) => {
        return iller.filter((innerItem) => {
            return innerItem.region === item.text
        })
        }).flat(Infinity)
        dispatch(multipleCitySelectArray(selectedCities));
    },[gunlukAracListesiRegionCanGos])

    // useEffect(() => {
    //     if (devamliAraclarPlakas?.length === 1 && [1, 2, 3, 4, 7, 8].includes(devamliAraclarPlakas[0].truckTypeId)) {
    //         dispatch(setSelectedPlateNumber(devamliAraclarPlakas[0]));
    //     }
    // }, [devamliAraclarPlakas]);

    const handleSave = () => {
        setIsSubmitted(true)
        if( firstLastName && phoneNumber && selectedPlateNumber && (!selectedTrailerPlateNumber || [1, 2, 3].includes(selectedPlateNumber.truckTypeId))){
                
                const postDriverData = {
                    firstLastName:  firstLastName,
                    phoneNumber: (phoneNumber.startsWith('90') || phoneNumber.startsWith('+90')) ? phoneNumber?.slice(2) : phoneNumber,
                    isContinueVehicle: isContinueVehicle?.bool, 
                    isReferenceDriver: isReferenceDriver?.bool,
                    devamliAraclarPlakas: devamliAraclarPlakas?.map((item) => {
                        return {"plate": item?.plate, "truckType": item?.truckType, "truckTypeId": item?.truckTypeId, "trailerTypeId": item?.caseType?.id}
                    }),
                    gunlukArac:  {
                        "vehicleStatus": vehicleCurrentLocation,
                        "vehicleCurrentLocation": vehicleCurrentLocation,
                        "timeToWaste": timeToWaste || null,
                        "truckPlate": selectedPlateNumber?.plate,
                        "trailerPlate": selectedPlateNumber?.trailerPlate,
                        "gunlukAracListesiCityCanGos": gunlukAracListesiCityCanGos?.map((item) => {
                            return {cityCanGo: item?.value}
                        }),
                        "gunlukAracListesiRegionCanGos": gunlukAracListesiRegionCanGos?.map((item) => {
                            return {regionCanGo: item?.text}
                        })
                    }
                }
                dispatch(getDevamliAracItem(postDriverData))
                
                dispatch(addSiraListesi(postDriverData))
        }
    }

  return (
    <Container>
    <div onClick={(e) =>{ e.stopPropagation(); }} className="inputs">
            <div className="row">
                <TextInput inputWidth="100%" name="firstLastName" data={firstLastName} labelText="Adı Soyadı" keyData="firstLastName" />
                {
                    isSubmitted && !firstLastName &&
                    <p className="error">Zorunlu alan</p>
                }
            </div>
            <div className="row">
                <InputPhoneFormat data={phoneValue} setData={setPhoneValue} labelText="Telefon No" name="phoneNumber"/>
                {
                    isSubmitted && !phoneNumber &&
                    <p className="error">Zorunlu alan</p>
                }
            </div>
            <div className="row">
                <BoolInput options={BoolData} inputWidth="100%" name="isContinueVehicle" data={isContinueVehicle} labelText="Devamlı Araç mı?" keyData="isContinueVehicle" />
                {
                    isSubmitted && !isContinueVehicle &&
                    <p className="error">Zorunlu alan</p>
                }
            </div>
            <div className="row">
                <BoolInput options={BoolData} inputWidth="100%" name="isReferenceDriver" data={isReferenceDriver} labelText="Bu Sürücüye Referans mısınız?" keyData="isReferenceDriver" />
                {
                    isSubmitted && !isReferenceDriver &&
                    <p className="error">Zorunlu alan</p>
                }
            </div>
           
            <div className="row relative">
                <div className="add-plate" onClick={()=>dispatch(addDevamliAraclarPlaka())}>Araç Ekle</div>
            </div>

            {devamliAraclarPlakas.map((item,i)=>{
                const newIndex = i+1
                return(
                <div>
                    <div className="row space">
                        <div className="plate-title">{newIndex}. Araç</div>
                        {[1, 2, 3, 4, 7, 8].includes(item.truckTypeId) ?
                            <div className={(selectedPlateNumber === item) ? "selected-plate" : "select-plate"} onClick={() => dispatch(setSelectedPlateNumber(selectedPlateNumber === item ? null : item))}>
                                {selectedPlateNumber === item ? "Araç Seçildi" : "Sıraya Eklemek İçin Seç"}
                            </div>
                        :
                            <div className={(selectedTrailerPlateNumber === item) ? "selected-plate" : "select-plate"} onClick={() => dispatch(setSelectedTrailerPlateNumber(selectedTrailerPlateNumber === item ? null : item))}>
                                {selectedTrailerPlateNumber === item ? "Dorse Seçildi" : "Sıraya Eklemek İçin Seç"}
                            </div>
                        }
                        {devamliAraclarPlakas?.length > 1 && <div className="plate-delete" onClick={()=>dispatch(deleteDevamliAraclarPlaka(item))}>Araç Sil</div> }
                    </div>
                    <div className="row">
                        <PlateInput inputWidth="100%" name={`plate${i}`} data={item} keyData="plate" labelText="Araç Plaka"/>
                    </div>
                    <div className="row">
                        <SelectAracInput options={AdminAracEkleOptions} inputWidth="100%" name={`truckType${i}`} data={item} labelText="Araç Türü" />
                    </div>
                    {
                        item?.truckType !== "Çekici" && 
                        <div className="row">
                            <KasaTipiInput aracTypes={AdminAracEkleOptions} inputWidth="100%" name={`caseType${i}`} data={item} labelText="Kasa Tipi" />
                        </div>
                    }
                </div>
            )})}
            
            <div className="daily-inputs">
                <div className="title">Sıraya Kayıt</div>
                <div className="row">
                    <SelectAracDurumuInput
                        options={aracDurumu}
                        inputWidth="100%"
                        name="vehicleStatus"
                        data={vehicleStatus}
                        labelText="Araç Durumu"
                        keyData="vehicleStatus"
                    />
                </div>
                <div className="row">
                    <AracNeredeInput
                        options={locationData}
                        inputWidth="100%"
                        name="vehicleCurrentLocation"
                        data={vehicleCurrentLocation}
                        labelText="Araç Nerede"
                        keyData="vehicleCurrentLocation"
                    />
                </div>
                <div className="row">
                    <DateInput
                        options={aracDurumu}
                        inputWidth="100%"
                        name="timeToWaste"
                        data={timeToWaste}
                        labelText="Boşa Çıkma Zamanı"
                        keyData="timeToWaste"
                    />
                </div>
                <div className="row">
                    <GidebilecekBolgelerInput
                        options={bolgeOptions}
                        inputWidth="100%"
                        name="gunlukAracListesiRegionCanGos"
                        data={gunlukAracListesiRegionCanGos}
                        labelText="Hangi Bölgelere Gidebileceği"
                        keyData="gunlukAracListesiRegionCanGos"
                    />
                </div>
                <div className="row">
                    <GidebilecekIllerInput
                        options={iller}
                        inputWidth="100%"
                        name="gunlukAracListesiCityCanGos"
                        data={gunlukAracListesiCityCanGos}
                        labelText="Hangi İllere Gidebileceği"
                        keyData="gunlukAracListesiCityCanGos"
                    />
                </div>
            </div>
            {
                !selectedPlateNumber && devamliAraclarPlakas && isSubmitted &&
                <div className="err">
                    <p>Lütfen sıraya eklemek istediğiniz aracı seçiniz.</p>
                    
                </div>
            }
            <p className="err">{errorMessage}</p>

            {
                isSubmitted && (selectedPlateNumber?.truckTypeId === 5 || selectedPlateNumber?.truckTypeId === 6) && 
                <div className="err">
                    <p>Sıraya eklemek dorse seçtiiz. Lütfen bir adet de çekici seçiniz.</p>
                </div>
            }

            {
                isSubmitted && selectedTrailerPlateNumber && !selectedPlateNumber &&
                <div className="err">
                    <p>Yalnızca dorse ile sıraya ekleme yapamazsınız. Lütfen araç seçimi de yapınız.</p>
                </div>
            }

            {
                isSubmitted && selectedTrailerPlateNumber && ![1, 2, 3].includes(selectedPlateNumber?.truckTypeId) &&
                <div className="err">
                    <p>Dorse seçili ise yalnızca çekici, kırkayak ve 10 teker kamyon araçlarından birini seçebilirsiniz.</p>
                </div>
            }

            <div ref={bottomRef} className="btn">
                <Btn bgColor="#E85446" width="150px" handleClick={handleSave} color="#fff">{loadingAddDriver ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Kaydet"}</Btn>
                <Btn bgColor="transparent" width="150px" handleClick={() => {dispatch(showModal(null)); dispatch(clearJobListWithoutGunlukAraclar())}} color="#E85446">Kapat</Btn>
            </div>
        </div>
    </Container>
  )
}

export default NewUserContent